angular.module("mail_accounts")

    .controller("MailAccountsListCtrl", ['LoginService', '$rootScope', '$scope', '$http', '$interval', '$q', 'i18nService', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate', '$state',
        function (LoginService, $rootScope, $scope, $http, $interval, $q, i18nService, Restangular, gridService, modalService, $uibModal, $filter, $translate, $state) {

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("MAIL_ACCOUNTS_WRITE");

            $rootScope.title = $filter('translate')('mail_accounts.title');

            $rootScope.breadcrumb = [
                { title: $filter('translate')('mail_accounts.title') }
            ];

            $scope.gridOptionsMailAccounts = {
                pdfTitle: $filter('translate')('mail_accounts.title'),
                exporterMenuCsv: true,
                enableGridMenu: true,
                gridMenuShowHideColumns: false,
                enableSorting: true,
                paginationPageSizes: [20, 40, 60],
                paginationPageSize: 20,
                rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },
                columnDefs: [
                  { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                    { name: 'name', displayName: $filter('translate')('mail_accounts.name'), enableFiltering: true, enableHiding: false },
                        { name: 'email', displayName: $filter('translate')('mail_accounts.email'), enableFiltering: true, enableHiding: false },
                    { name: 'reply_to', displayName: $filter('translate')('mail.reply_to'), enableFiltering: false, enableHiding: false },
                    { name: 'use_by_default', enableFiltering: true, displayName: $filter('translate')('mail_accounts.use_by_default'), cellTemplate: "<div class=\"ui-grid-cell-contents\" style=\"text-align: center;\">" +
                        "<span ng-if=\"!row.entity.use_by_default\" class=\"label label-danger\" style=\"display: inline-block;height: 15px;width: 15px;border-radius: 50%;\"></span>" +
                        "<span ng-if=\"row.entity.use_by_default\" class=\"label label-primary\" style=\"display: inline-block;height: 15px;width: 15px;border-radius: 50%;\"></span>" +
                        "</div>" },
                  {
                      name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                          { title: $filter('translate')('mail_accounts.button_edit'), action: 'ui-sref="mail_accounts.edit({id:row.entity.id})"', cssIconClass: "fa fa-edit" },
                          { title: $filter('translate')('mail_accounts.button_delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                      ], { cssClass: "pull-right" })
                  },
                ],
                getData: function (options) {
                    return Restangular.all('MailAccounts').getList(options);
                }
            };

            $scope.goToEdit = function (rowEntity) {
                $state.go("mail_accounts.edit", { id: rowEntity.id });
            }

            $scope.deleteDialog = function (id, name) {
                $scope.id = id;
                $scope.name = name;
                modalService.confirm({
                    title: $filter('translate')('mail_accounts.button_delete'),
                    message: $filter('translate')('mail_accounts.delete_message') + " " + $scope.name + "?",
                    onAccept: function () {
                        Restangular.one('MailAccounts', $scope.id).remove().then(function () {
                            toastr.success($filter('translate')('mail_accounts.deleted_success'));
                            $scope.gridOptionsMailAccounts.gridApi.core.raise.itemDeleted($scope);

                        }, function (response) {
                            $scope.errorMessage = response.message;
                        });
                    }
                });
            };

        }])

;